import { defineMessages } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { useCurrentUser } from 'modules/utils';
import { useEffect, useRef } from 'react';
import { notificationService } from 'services/notification';
import { routingService } from 'services/routing';
import { getPath, Path } from 'urlBuilder';

import { getRequest } from '../selectors/pageSelectors';
import { getRequestEditMode, RequestEditMode } from '../selectors/requestSelectors';

export const messages = defineMessages('pages.RequestForm.useRedirectDelegatedApproverDueToRestrictions', {
    operationNotAllowed: 'Operation not allowed',
});

export const useRedirectDelegatedApproverDueToRestrictions = () => {
    const request = useSelector(getRequest);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const me = useCurrentUser();
    const redirected = useRef(false);

    useEffect(() => {
        if (redirected.current) return;

        if (editMode === RequestEditMode.Approver) {
            const activeStep = selectors.request.getActiveStep(request);
            const canEditAsDelegatedApprover = selectors.request.getCanEditAsDelegatedApprover(
                me.id,
                activeStep?.participants
            );

            if (!canEditAsDelegatedApprover) {
                redirected.current = true;
                routingService.replace(getPath(Path.request, request.id, request.companyId));
                notificationService.showErrorToast(messages.operationNotAllowed);
            }
        }
    }, [editMode, me.id, request]);
};
